import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();

  const breadcrumbMap = {
    '/': { label: 'Início', depth: 0 },
    '/tabela': { label: 'Tabela de Severidade', depth: 1 },
    '/pediatrica': { label: 'Escala Pediátrica', depth: 1 },
    '/ecg-p': { label: 'ECG-P (Com Pupilas)', depth: 1 },
    '/como-avaliar': { label: 'Como Avaliar', depth: 1 },
    '/sobre': { label: 'Sobre Glasgow', depth: 1 },
    '/referencias': { label: 'Referências', depth: 1 },
    '/privacidade': { label: 'Privacidade', depth: 1 },
    '/termos': { label: 'Termos de Uso', depth: 1 },
  };

  const buildBreadcrumbs = () => {
    const paths = ['/'];

    if (location.pathname !== '/') {
      paths.push(location.pathname);
    }

    return paths.map((path, index) => ({
      path,
      label: breadcrumbMap[path]?.label || 'Página',
      position: index + 1,
      isLast: index === paths.length - 1,
    }));
  };

  const breadcrumbs = buildBreadcrumbs();

  useEffect(() => {
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((item) => ({
        '@type': 'ListItem',
        position: item.position,
        name: item.label,
        item: `${window.location.origin}${item.path}`,
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [breadcrumbs]);

  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav aria-label="Navegação estrutural" className="site-breadcrumb">
      <div className="page site-breadcrumb__inner">
        <ol className="site-breadcrumb__list">
          {breadcrumbs.map((item) => (
            <li key={item.path} className="site-breadcrumb__item">
              {item.isLast ? (
                <span className="site-breadcrumb__current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link to={item.path} className="site-breadcrumb__link">
                  {item.label}
                </Link>
              )}
              {!item.isLast && <span className="site-breadcrumb__sep">/</span>}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
